<template>
  <div class="slider-inner slider-f">
    <Logo />

    <div class="f1 animated fadeInUp">
      <div class="inner" @touchstart.stop>
        <img class="f11" src="~images/f/f_1_1.png" />
        <img class="f12" src="~images/f/f_1_2.png" />
        <img class="f13" src="~images/f/f_1_3.png" />
        <img class="f14" src="~images/f/f_1_4.png" />
        <img class="f15" src="~images/f/f_1_5.png" />
        <img class="f16" src="~images/f/f_1_6.png" />
        <img class="f17" src="~images/f/f_1_7.png" />
        <img class="f18" src="~images/f/f_1_8.png" />
        <img class="f19" src="~images/f/f_1_9.png" />
        <img class="f110" src="~images/f/f_1_10.png" />
        <img class="f111" src="~images/f/f_1_11.png" />
      </div>
    </div>
    <img class="f2 animated zoomIn" src="~images/f/f_2.png" />
    <div class="f3 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_4.png" />
    </div>
    <div class="f4 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_3.png" />
    </div>
    <img class="f5 animated fadeInLeft" src="~images/b/b_7.png" />
    <img class="f6 animated fadeInRight" src="~images/b/b_8.png" />
    <img class="f7" src="~images/b/b_9.png" />
    <div class="f8 animated fadeInRight">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_5.png" />
    </div>
    <div class="f9 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/f/f_3.png" />
    </div>

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderE",
};
</script>

<style lang="less" scoped>
.slider-f {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  .f1 {
    position: absolute;
    top: 20%;
    right: 5%;
    bottom: 7%;
    left: 5%;
    padding: 0.47rem 0.15rem 0.2rem;
    background: url("~images/d/d_1.png") center top / 100% 100%;
    .inner {
      position: relative;
      height: 100%;
      overflow: auto;
      .f11 {
        width: 80%;
        margin: 0.5rem auto;
      }
      .f12 {
        width: 1.92rem;
        margin-bottom: 0.34rem;
      }
      .f13 {
        width: 5.11rem;
        margin-left: 0.1rem;
      }
      .f14 {
        width: 1.92rem;
        margin: 0.6rem 0 0.34rem;
      }
      .f15,
      .f16,
      .f17 {
        width: 5.11rem;
        margin: 0 0 0.36rem 0.1rem;
      }
      .f18 {
        position: absolute;
        top: 1.9rem;
        right: 0.2rem;
        width: 1rem;
      }
      .f19 {
        position: absolute;
        top: 4.6rem;
        right: 0.05rem;
        width: 1.1rem;
      }
      .f110 {
        position: absolute;
        top: 6rem;
        right: 0.2rem;
        width: 1.06rem;
      }
      .f111 {
        position: absolute;
        top: 7.8rem;
        right: 0.05rem;
        width: 1.09rem;
      }
    }
  }
  .f2 {
    position: absolute;
    top: 13.5%;
    left: 50%;
    width: 4.42rem;
    margin-left: -4.42/2rem;
  }
  .f3 {
    position: absolute;
    top: 17%;
    right: 0.55rem;
    width: 1.21rem;
  }
  .f4 {
    position: absolute;
    top: 14.5%;
    left: 0.7rem;
    width: 0.53rem;
    img {
      animation-delay: 1s;
    }
  }
  .f5 {
    position: absolute;
    left: 0.5rem;
    bottom: 0;
    width: 1.8rem;
  }
  .f6 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 2rem;
  }
  .f7 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .f8 {
    position: absolute;
    bottom: 18%;
    left: 0;
    width: 0.79rem;
    z-index: 5;
  }
  .f9 {
    position: absolute;
    top: 30%;
    right: 0.05rem;
    width: 0.7rem;
    img {
      animation-delay: 0.5s;
    }
  }
}
</style>